import { render, staticRenderFns } from "./CoachStats.vue?vue&type=template&id=3f42e89b&scoped=true"
import script from "./CoachStats.vue?vue&type=script&lang=js"
export * from "./CoachStats.vue?vue&type=script&lang=js"
import style0 from "./CoachStats.vue?vue&type=style&index=0&id=3f42e89b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f42e89b",
  null
  
)

export default component.exports